import { GLOBALS_ADMIN } from './globals-admin';
import { API_PATH_PREFIX_ADMIN, API_PATH_PREFIX_AUTHENTICATION, API_PATH_PREFIX_USER } from '../api-path-prefixes';

const API_ORIGIN = 'https://api.dev.lexplus.digitalemenschen.dev';

export const environmentAdmin = {
  ...GLOBALS_ADMIN,
};

environmentAdmin.name = 'dev';
environmentAdmin.production = false;
environmentAdmin.support.audience = 'everyone';
environmentAdmin.apiConfiguration.baseUrl = `${API_ORIGIN}${API_PATH_PREFIX_ADMIN}`;
environmentAdmin.apiConfiguration.baseUrlAuth = `${API_ORIGIN}${API_PATH_PREFIX_AUTHENTICATION}`;
environmentAdmin.apiConfiguration.baseUrlUser = `${API_ORIGIN}${API_PATH_PREFIX_USER}`;
